/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import InputImage from '@/components/forms/InputImage'
import { useForm, Controller } from 'react-hook-form'
import { Button } from '@chakra-ui/react'
import { updateAssetCover } from '@/services/assets'
import { useAuth0 } from '@auth0/auth0-react'
import FormWrapper from '@/components/forms/FormWrapper'

const BodySetCover = ({
  urlImage,
  id,
  onClose = () => {},
  reloadItems,
  setStage = () => {}
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [hasAlert, setHasAlert] = useState(false)
  const { getAccessTokenSilently: getAccessToken } = useAuth0()

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm()
  const onSubmit = async (data) => {
    try {
      setHasAlert(false)
      const formData = new FormData()

      if (data.cover) {
        formData.append('cover', data.cover)
      }

      const response = await updateAssetCover({ id, formData }, getAccessToken)

      if (response?.id) {
        reloadItems && reloadItems()
        setStage('success')
        onClose()
      } else {
        setStage('error')
      }
    } catch (error) {
      setHasAlert(true)
    }
    setIsLoading(true)
  }

  return (
    <FormWrapper hasAlert={hasAlert}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="cover"
          control={control}
          render={({ field: { onChange, value, name } }) => (
            <InputImage
              className="mb-6"
              imageUrl={urlImage}
              onChange={onChange}
              value={value}
              name={name}
              error={errors.coverImage}
            />
          )}
        />
        <div className="flex gap-2 justify-end">
          <Button
            onClick={onClose}
            colorScheme='gray'
          >
            Cancel
          </Button>
          <Button
            type="submit"
            isLoading={isLoading}
            loadingText='Submitting'
          >
            Save
          </Button>
        </div>
      </form>
    </FormWrapper>
  )
}

export default BodySetCover
